<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
      <kendo-grid-component class="kendo-pointer-default"
        v-model="selected"
        value-key="idEstado"
        :id-vista="idVista"
        :spanish="spanish"
        :data="data"
        :kendo="kendo"
        :loading="isGeneralLoading"
        :selectedField="selectedField"
        @datastatechange="dataStateChange">
      </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="primary" :text="labelBtnExcel" icon="excelxls" @click="exportExcel" 
            :loading="isGeneralLoading || loadingExcel" :disabled="loadingExcel"/>
          <base-button-responsive mode="primary" :text="$t('configurations.link_status')" icon="plus" @click="golinkStatusToGroup" 
            :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
      >
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <base-button-item-list theme="dark" @click="unlink">
            <base-icon name="unlink" class="mr-2" />
              {{$t('app.unlink_entity')}}
          </base-button-item-list>
        </template>
      </base-table-select-actions-expand>
      <user-link-status-dialog 
        :dialogOpen="linkStatusToUserDialog" 
        :groupId="this.$route.params.id" 
        @toggleDialog="toggleDialogs" 
        @applyDialog="applyLinkHandler" 
      />
      <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import { bus } from '@/main'
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/GroupStatusFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { i18n } from '@/i18n'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import UserLinkStatusDialog from '@/components/UserLinkStatusDialog.vue'

import { getGroup } from '@/services/configurations/groups/getGroup'
import { getEstadosByGroupPag } from '@/services/configurations/groups/getEstadosByGroupPag'
import { linkGroupToStatuses } from '@/services/configurations/groups/linkGroupToStatuses'
import { unlinkGroupToStatuses } from '@/services/configurations/groups/unlinkGroupToStatuses'
import { getEstadosByGroupExcel } from '@/services/configurations/groups/getEstadosByGroupExcel'


export default {
  name: 'status-by-group',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    UserLinkStatusDialog,
  },
  data: function () {
    return {
      idVista: 48,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      showModal: false,
      linkStatusToUserDialog: false,
      spanish: true,
      header: {
        title: i18n.t('configurations.status_link'),
        icon: 'config',
        breadcrumb: null,
        url: 'configurations/groups/details'
      },
      vuexnamespace: 'groupstatus',
      selectedField: 'selected',
      filterPanel: false,
      loadingDataTable: false,
      data: null,
      selected: [],
    }
  },
  computed: {
    labelBtnExcel: function () {
      if (this.hasSelected) return `${i18n.t('app.export_excel')} (${i18n.t('app.selected')})`
      return i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.selected.length
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    }
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    }
  },
  created: function () {
  },
  mounted: async function () {
    const groupId = this.$route.params.id
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)

    const breadcrumbs = []
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      breadcrumbs.push({
        path: this.role === 3 ? 'configurationssa' : 'configurations',
        name: i18n.t('configurations.header')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: i18n.t('configurations.header')
      })
    }
    breadcrumbs.push({ path: 'configurations/groups', name: i18n.t('groups.header') })

    const group = await this.downloadData(groupId)
    breadcrumbs.push({ path: '', name: group.Nombre })
    this.$store.commit('app/setheaderBreadCrumb', group.Nombre)
    this.disableRoutes(group)

    this.header.breadcrumb = breadcrumbs

    this.data = await this.applyFilters()
  },
  methods: {
    disableRoutes: function (grupo) {
      const objDisableRoutes = {
        disableUsers: grupo.idTipo === 3,
        disableStatuses: grupo.idTipo === 1 || grupo.idTipo === 3 || grupo.VerTodoEstados,
        disableCompanies: grupo.idTipo === 1 || grupo.idTipo === 3 || grupo.VerTodoEmpresas,
      }
      bus.$emit('disableOptionsGroup', objDisableRoutes)
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleDialogs: function () {
      this.linkStatusToUserDialog = !this.linkStatusToUserDialog
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idGrupo: this.$route.params.id,
        descripcion: data.name ? data.name.value : null
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)

      // Columna 'idEstado' duplicada para 'Nombre'. Como es imposible identificar la columna visible/oculta, siempre se manda Descripcion
      if (objColumnas.length) {
        objColumnas[0].columna = 'Descripcion'
      }

      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        payload.listaIDs = this.selected
      }
      try {
        const response = await getEstadosByGroupExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'grupo-estados.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idGrupo: this.$route.params.id,
        descripcion: data.name ? data.name.value : null
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      try {
        const data = await this.getItemsData(objOrder, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      return this.data
    },
    getItemsData: async function (objOrder, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(objOrder, params)
      this.data = res.Respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (objOrder, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getEstadosByGroupPag(objOrder, params)
      if (data.blnError === true) {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      this.unselect()
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.unselect()
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    downloadData: async function (id) {
      let grupo = null
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          idGrupo: id
        }
        grupo = await getGroup(params)
        if (grupo.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', grupo))
        } else {
          grupo = grupo.Respuesta
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return grupo
    },
    unselect: function () {
      this.selected = []
    },
    unlink: async function () {
      const selected = this.selected
      await this.unlinkHandler(selected)
      // for await (const element of selected) {
      //   await this.unlinkHandler(element.IdTag)
      // }
      this.data = await this.applyFilters()
    },
    unlinkHandler: async function (estados) {
      try {
        this.$store.commit('setIsLoading', true)
        const idGrupo = this.$route.params.id
        const payload = { idGrupo: idGrupo, idEstados: estados }
        const response = await unlinkGroupToStatuses(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.unselect()
          this.doFeedback(i18n.t('feedback.success.entity_unlinked_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    golinkStatusToGroup: function () {
      this.linkStatusToUserDialog = !this.linkStatusToUserDialog
    },
    applyLinkHandler: async function (estados) {
      await this.linkHandler(estados)
      this.applyFilters()
    },
    linkHandler: async function (idEstados) {
      try {
        this.$store.commit('setIsLoading', true)
        const idGrupo = this.$route.params.id
        const payload = { idGrupo: idGrupo, idEstados: idEstados }
        const response = await linkGroupToStatuses(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.entity_linked_msg'), 'success')
          this.toggleDialogs()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang="scss" scoped></style>
